export function get() {

	return {
		title: 'style="font-size: 10pt; font-family:sans-serif; font-weight: normal; text-align: center; margin: 2px 0;"',
		subtitle: 'style="font-size: 9pt; font-family:sans-serif; text-align: center; margin: 2px 0;"',

		f32: 'style="font-size: 10pt; font-family:sans-serif; font-weight: normal; text-align: center; margin: 2px 0;"',
		f14: 'style="font-size: 8pt; font-family:sans-serif; text-align: center; margin: 2px 0; opacity: 0.9;"',
		f15: 'style="font-size: 8pt; font-family:sans-serif; font-weight: normal; margin: 2px 0; opacity: 0.9;"',

		tableTitle: 'style="font-size: 9pt; font-family:sans-serif; font-weight: bold; margin: 2px 0; opacity: 0.9;"',

		table: 'style="width: 100%; border-collapse: collapse; margin: 2px 0;"',

		th: 'style="font-family:sans-serif; font-size: 9pt; font-weight: normal; padding: 2px; border: 1px solid #ccc;"',
		thNoline: 'style="font-family:sans-serif; font-size: 9pt; font-weight: normal; padding: 2px;"',

		td: 'style="font-family:sans-serif; font-size: 8pt; padding: 2px; border: 1px solid #ccc;"',
		td0: 'style="font-family:sans-serif; font-size: 8pt; padding: 2px;"',
		td0t: 'style="font-family:sans-serif; font-size: 8pt; padding: 2px; opacity: 0.76;"',

		trGray: 'style="background-color: #f2f2f2;"',

		totalLabel: 'style="font-family:sans-serif; font-size: 9pt; font-weight: bold; text-align: right; padding: 2px;"',
		totalCell: 'style="font-family:sans-serif; font-size: 9pt; font-weight: bold; padding: 2px; border: 1px solid #ccc;"',
	}


}

export function getCliente() {
	return {

		title: 'style="font-size: 10pt; font-family:sans-serif; font-weight: normal; text-align: center; margin: 2px 0;"',
		subtitle: 'style="font-size: 9pt; font-family:sans-serif; text-align: center; margin: 2px 0;"',
		paragraph: 'style="font-size: 8pt; font-family:sans-serif; margin: 2px 0; opacity: 0.9;"',

		table: 'style="width: 100%; border-collapse: collapse; margin: 2px 0;"',

		th: 'style="font-family:sans-serif; font-size: 9pt; font-weight: normal; padding: 2px; border: 1px solid #ccc;"',
		td: 'style="font-family:sans-serif; font-size: 8pt; padding: 2px; border: 1px solid #ccc;"',

		trGray: 'style="background-color: #f2f2f2;"',

		totalLabel: 'style="font-family:sans-serif; font-size: 9pt; font-weight: bold; text-align: right; padding: 2px;"',
		totalCell: 'style="font-family:sans-serif; font-size: 9pt; font-weight: bold; padding: 2px; border: 1px solid #ccc;"',

		right: 'style="text-align: right;"',
		center: 'style="text-align: center;"',

		pageBreak: 'style="page-break-after: always;"',
	}
}